import { Layout } from "@/components/layout";
import { SEOHead } from "@/components/seo-head";
import { ABOUT } from "@/lib/content";
import { motion } from "framer-motion";

export default function AboutPage() {
  return (
    <Layout>
      <SEOHead title={ABOUT.seo.title} description={ABOUT.seo.description} />

      <section className="pt-24 pb-20 md:pt-32 md:pb-24 bg-navy text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-brand-gradient opacity-10 mix-blend-overlay" />
        <div className="container mx-auto px-4 md:px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-3xl"
          >
            <div className="text-sm font-semibold text-cyan-400 mb-4 tracking-wider uppercase">
              {ABOUT.eyebrow}
            </div>
            <h1 className="text-display mb-6">
              {ABOUT.title}
            </h1>
            <p className="text-body-lg text-slate-300">
              {ABOUT.subtitle}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 md:py-32">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">

            <div>
              <h2 className="text-h2 mb-12 text-navy dark:text-white">Our story</h2>
              <div className="space-y-12 border-l border-border pl-8 relative">
                {ABOUT.story.map((chapter, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    className="relative"
                  >
                    <div className="absolute -left-[41px] top-1.5 h-4 w-4 rounded-full bg-indigo-500 border-4 border-background" />
                    <h3 className="text-h4 mb-3 text-navy dark:text-white">{chapter.heading}</h3>
                    <p className="text-body text-slate-600 dark:text-slate-400 leading-relaxed">
                      {chapter.body}
                    </p>
                  </motion.div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-h2 mb-12 text-navy dark:text-white">Values</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {ABOUT.values.map((value, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    className="bg-slate-50 dark:bg-navy/30 p-6 rounded-2xl"
                  >
                    <h3 className="text-base font-bold mb-3 text-navy dark:text-white">{value.title}</h3>
                    <p className="text-sm text-slate-600 dark:text-slate-400">
                      {value.body}
                    </p>
                  </motion.div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>
    </Layout>
  );
}
